/**
 * Campaign sign-up attribution (SDA-267)
 *
 * Shape of the client-persisted attribution blob attached out-of-band to
 * sign-up requests (register, activate-dormant, bookings, inquiries, waitlist).
 * Strict so a forged blob can't smuggle arbitrary keys into the jsonb column;
 * consumers safeParse and DROP the blob on any failure — attribution must never
 * block a sign-up.
 */
import { z } from 'zod';
export const attributionSchema = z
    .object({
    campaign_id: z.string().uuid(),
    contact_id: z.string().uuid().optional(),
    utm_source: z.string().max(100).optional(),
    utm_campaign: z.string().max(150).optional(),
    landed_at: z.string().datetime().optional(),
})
    .strict();
//# sourceMappingURL=attribution.js.map